<template>
<div>
<div v-if="returnUserLoaded">
    
    
    <v-app-bar color="deep-purple accent-4"
     app dark  clipped-left>
    </v-app-bar>
  <v-navigation-drawer
        
        class="elevation-2"
        app
        clipped
      >
        <user-account-widget></user-account-widget>

        <v-divider></v-divider>
        <v-list
          nav
          dense
        >
          <v-list-item :to="'/admin/splash'" link>
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item :to="'/admin/settings'"  link>
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
          <v-list-item :to="'/admin/updates'" link>
            <v-list-item-icon>
              <v-icon>mdi-newspaper-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Updates</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

<v-main style="min-height:100vh">
      <v-container>
        <router-view></router-view>
      </v-container>
</v-main>
</div>
<div v-else style="background:red;">
  No user
  </div>
</div>
</template>



<script>


import UserAccountWidget from '@/components/Admin/UserAccountWidget.vue';

import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'Admin',
  
  created: function () {
    // `this` points to the vm instance

 
  },
  computed:{
      ...mapGetters(["returnAccount", "returnUserLoaded"]),
    },
  data(){
    return {  
     
    }
  },

  methods: {
    ...mapActions(["loadAccount"]),
  
  },
  components: {
    UserAccountWidget
  }
}
</script>

